import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ClaimTypeApiService } from './claim-type.api.service';
import { ClaimTypeEffects } from './claim-type.effects';
import {
  claimTypeReducer,
  claimTypeInitialState,
  IClaimTypeState,
} from './claim-type.reducer';
import { ClaimTypeService } from './claim-type.service';
import { claimTypeFeatureKey } from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<IClaimTypeState>(
      claimTypeFeatureKey,
      claimTypeReducer,
      {
        initialState: claimTypeInitialState,
      },
    ),
    EffectsModule.forFeature([ClaimTypeEffects]),
  ],
  providers: [ClaimTypeApiService, ClaimTypeService],
})
export class StoreClaimTypeModule {}
